<template>



<div class="size mt-3 mb-1 " @click="goToList(colecaoId)" >
     

    
		<figure class="card " >
 
                
			<a href="#" class="img-wrap " > 
                
				<img img :src="colecaoImg" alt="" loading="lazy">
                
			</a>
            
			<figcaption class="info-wrap mt-2" >
      
				<a href="#" class="price ">{{colecaoName}} </a>
                <p href="#" class="brand-name">{{colecaoDescricao}}</p>
			
				<div class="mt-2">				
                </div> <!-- action-wrap.end -->
			</figcaption>
		</figure> <!-- card // -->
	</div> <!-- col.// -->


</template>

<script>

    export default {
        components: {
         
        },
        data() {
            return {
            }
        },
        props: {

            colecaoName: {
                type: String,
            },
            colecaoDescricao: {
                type: String,
            },
            colecaoImg: {
                type: String,
            },
            colecaoId: {
                type: Number,
            },
            Loading: {
                type: Boolean,
              
            },
          
            colecaoProducts: {
                type: Array,
            },
          
        },
        methods: {
            goToList(id){
                console.log(id)
                localStorage.setItem('colecao',id)
                this.$router.push({name:'product_list',params:{colecao:id}})
            }
        },
    }
</script>

<style scoped>
.card {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 20rem;
    max-height: 17rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 1.6rem ;
    
}
.blur {
    position: absolute;
    width: 100vw;
    height: 100%;
    left: 0;
    top: 0;
    background: linear-gradient(180deg, #3a3a3a 7.73%, rgba(196, 196, 196, 0) 35%);
}

.brand-name{
    
    color:var(--main-black);
    font-size: .82rem;
    line-height: 1.2;
 
}

.img-wrap {
    text-align: center;
    display: contents;   
    
}

[class*='product-'] .img-wrap img {
    height: 100%;
    min-height: 7.55rem;
    min-height: 10.55rem;
    width: 70%;
    display: inline-block;
    -o-object-fit: cover;
    object-fit: contain;
    margin:auto;
    background-clip: border-box;

    border-radius: 1.6rem ;
}
.card-product-grid .info-wrap {
    overflow: hidden;
    padding: 6%;
}

img {
     border-radius: 1.6rem ;
}

.size {
    flex: 0 0 75%;
    max-width: 80%;
    position: relative;
    width: 100%;
    padding-right: .5rem;
    padding-left: .5rem;
    
}


  @media (min-width: 1000px) {
.size {
    flex: 0 0 25%;
    max-width: 50%;
    position: relative;
    width: 100%;
    padding-right: .6rem;
    padding-left: .6rem;
    
}
   
  }
</style>